import useSWR, { type SWRConfiguration } from "swr";
import { apiClient } from "@/lib/api/client";
import { apiPaths } from "@/lib/api/paths";
import type { Individual } from "@typings/entities/individuals";

async function getIndividualById(id: string): Promise<Individual> {
  const response = await apiClient.get<Individual>(
    apiPaths.individuals.getById(id),
  );
  return response.data;
}

export function useGetIndividualById(
  individualId: string | null,
  options?: SWRConfiguration,
) {
  return useSWR(
    individualId ? [`fetch-individual-${individualId}`] : null,
    () => getIndividualById(individualId!),
    options,
  );
}
